import { findPage } from "@/api/ik/data/dataApi"

export default {
  state: {
    labels: []
  },
  mutations: {
    /**
     * 设置标签信息
     * @param state
     * @param labels
     */
    setLabels: (state, labels) => {
      state.labels = labels
    }
  },
  actions: {
    /**
     * 设置标签信息
     * @param commit
     * @param labels
     */
    async setLabels({ commit }) {
      const res = await findPage("health/content/label/contentlabel", {}, 20, 1)
      const labels = res.data.list
      commit('setLabels', labels)
    }
  },
  getters: {
    /**
     * 在标签组里找到对应id的标签
     * @param state
     * @returns {function(*): *}
     */
    getLabelInfo: (state) => (id) => {
      return state.labels.find((label) => label.id === parseInt(id))
    }
  }
}
